import axios from 'axios'

const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/api' : '/api',
  timeout: 10000,
  withCredentials: true // 支持session
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    return Promise.reject(error)
  }
)

// Banner 相关
export const bannerApi = {
  getList: () => api.get('/banner/list'),
  getById: (id) => api.get(`/banner/${id}`),
  create: (data) => api.post('/banner', data),
  update: (id, data) => api.put(`/banner/${id}`, data),
  delete: (id) => api.delete(`/banner/${id}`)
}

// 业务板块相关
export const businessApi = {
  getList: () => api.get('/business/list'),
  getById: (id) => api.get(`/business/${id}`),
  create: (data) => api.post('/business', data),
  update: (id, data) => api.put(`/business/${id}`, data),
  delete: (id) => api.delete(`/business/${id}`)
}

// 案例相关
export const caseApi = {
  getList: (params) => api.get('/case/list', { params }),
  getById: (id) => api.get(`/case/${id}`),
  create: (data) => api.post('/case', data),
  update: (id, data) => api.put(`/case/${id}`, data),
  delete: (id) => api.delete(`/case/${id}`)
}

// 新闻相关
export const newsApi = {
  getList: (params) => api.get('/news/list', { params }),
  getById: (id) => api.get(`/news/${id}`),
  create: (data) => api.post('/news', data),
  update: (id, data) => api.put(`/news/${id}`, data),
  delete: (id) => api.delete(`/news/${id}`)
}

// 团队成员相关
export const teamApi = {
  getList: () => api.get('/team/list'),
  getById: (id) => api.get(`/team/${id}`),
  create: (data) => api.post('/team', data),
  update: (id, data) => api.put(`/team/${id}`, data),
  delete: (id) => api.delete(`/team/${id}`)
}

// 统计数据相关
export const statsApi = {
  getStats: () => api.get('/stats'),
  getDashboardStats: () => api.get('/stats/dashboard')
}

// 认证相关
export const authApi = {
  login: (data) => api.post('/auth/login', data),
  logout: () => api.post('/auth/logout'),
  checkLogin: () => api.get('/auth/check'),
  changePassword: (data) => api.post('/auth/change-password', data),
  getProfile: () => api.get('/auth/profile'),
  updateProfile: (data) => api.put('/auth/profile', data)
}

// 文件上传相关
export const fileApi = {
  upload: (file, folder) => {
    const formData = new FormData()
    formData.append('file', file)
    if (folder) {
      formData.append('folder', folder)
    }
    return api.post('/file/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  delete: (objectName) => api.delete('/file/delete', { params: { objectName } })
}

// 留言相关
export const messageApi = {
  create: (data) => api.post('/message', data),
  getList: (params) => api.get('/message/list', { params }),
  getById: (id) => api.get(`/message/${id}`),
  update: (id, data) => api.put(`/message/${id}`, data),
  delete: (id) => api.delete(`/message/${id}`),
  process: (id) => api.put(`/message/${id}/process`)
}

// 招聘信息相关
export const recruitmentApi = {
  getList: (params) => api.get('/recruitment/list', { params }),
  getById: (id) => api.get(`/recruitment/${id}`),
  create: (data) => api.post('/recruitment', data),
  update: (id, data) => api.put(`/recruitment/${id}`, data),
  delete: (id) => api.delete(`/recruitment/${id}`)
}

// 人才理念相关
export const recruitmentConceptApi = {
  getList: () => api.get('/recruitment/concept/list'),
  getById: (id) => api.get(`/recruitment/concept/${id}`),
  create: (data) => api.post('/recruitment/concept', data),
  update: (id, data) => api.put(`/recruitment/concept/${id}`, data),
  delete: (id) => api.delete(`/recruitment/concept/${id}`)
}

// 合作伙伴相关
export const partnerApi = {
  getList: (params) => api.get('/partner/list', { params }),
  getById: (id) => api.get(`/partner/${id}`),
  create: (data) => api.post('/partner', data),
  update: (id, data) => api.put(`/partner/${id}`, data),
  delete: (id) => api.delete(`/partner/${id}`)
}

export default api





